import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Modal from '@mui/material/Modal';
import { isMobile } from 'react-device-detect';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router';
import LoginLink from './LoginLink';
import { Fade } from '@mui/material';
import LoginForm from 'domain/views/LoginForm';
import { useEffect, useState } from 'react';
import { history } from 'state/store';

const Login = () => {
  const location = useLocation();
  const [root, setRoot] = useState<HTMLElement | null>(null);

  const openModal = () => {
    history.push({ hash: 'buyerLogin' });
  };

  const closeModal = () => {
    history.go(-1);
  };

  useEffect(() => {
    if (location.pathname !== '/buyers/sign_in') {
      return;
    }

    const container1 = document.getElementById('login-block');
    const container2 = document.getElementById('loginForm');
    const mountRoot = container1 || container2;

    if (!mountRoot) {
      return;
    }

    const r = document.createElement('div');
    r.setAttribute('style', 'padding: 0px 15px;');

    mountRoot.replaceWith(r);

    setRoot(r);
  }, []);

  if (location.pathname === '/buyers/sign_in') {
    if (!root) {
      return null;
    }

    return createPortal(<LoginForm />, root);
  }

  if (isMobile) {
    return (
      <>
        <LoginLink />

        {createPortal(
          <SwipeableDrawer
            open={location.hash === '#buyerLogin'}
            anchor="bottom"
            onClose={closeModal}
            onOpen={openModal}
            PaperProps={{
              sx: {
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
              },
            }}
          >
            <LoginForm
              isModal
              isMobile
            />
          </SwipeableDrawer>,
          document.body,
        )}
      </>
    );
  }

  return (
    <>
      <LoginLink />

      {createPortal(
        <Modal
          open={location.hash === '#buyerLogin'}
          onClose={closeModal}
          closeAfterTransition
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={location.hash === '#buyerLogin'}>
            <LoginForm isModal />
          </Fade>
        </Modal>,
        document.body,
      )}
    </>
  );
};

export default Login;
